<template>
  <div id="new_user">
    <dd-header
      :headerType=1
    />
    <div id="container">
      <div id="content">
        <div class="title">
          <h2>ユーザー情報入力</h2>
          <label>下記フォームより入力してください。</label>
        </div>
        <dd-user-input
          ref="userInputRef"
          :isEdit="false"
          :userForm="userForm"
          :isRequestPayment="isRequestPayment"
        />
      </div>
      <div id="regist_btn">
        <button class="main_btn cancel_btn" @click="goBack()" v-if="isNewCorp">戻る</button>
        <button class="main_btn" @click="confirm()" v-bind:disabled="isDisabled">登録する</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'

// Module
import Header from '../components/common/DcHeader'
import UserInput from '../components/user/UserInput'

export default {
  name: 'RegistUserConfirm',
  components: {
    'dd-header': Header,
    'dd-user-input': UserInput
  },
  props: {
    edit: Boolean
  },
  data () {
    return {
      userForm: {
        corpUserId: '',
        corpType: '',
        corpDept: '',
        userLastName: '',
        userFirstName: '',
        userLastNameKana: '',
        userFirstNameKana: '',
        email: '',
        infosrc: '',
        inviteCode: '',
        recvInfo: false,
        consent: false,
        password: '',
        confirmPassword: ''
      },
      isRequestPayment: false
    }
  },
  computed: {
    isNewCorp: function () {
      if (!this.userForm || this.userForm.corpUserId === undefined || this.userForm.corpUserId === '') {
        return true
      }
      return false
    },
    isDisabled: function () {
      if (this.userForm.consent === true) {
        return false
      }
      return true
    }
  },
  methods: {
    goBack: function () {
      this.$router.go(-1)
    },
    confirm: function () {
      let ret = this.$refs.userInputRef.confirm()
      if (!ret) return

      // ストレージに保存する
      App.setLocalStorage(DC_STORAGE_KEY.USER_DATA, this.userForm)

      this.$router.push({
        name: 'RegistUserConfirm'
      })
    },
    tokenCheck: function () {
      let payload = {
        userEmail: this.$route.query.email,
        token: this.$route.query.token,
        corpUserId: this.$route.query.userId
      }
      axios.post(DC_URL.USER + '/new/check-new-user-token', payload
      ).then(response => {
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    }
  },
  mounted () {
  },
  created () {
    let corpForm = App.getLocalStorage(DC_STORAGE_KEY.CORP_DATA)
    let lForm = App.getLocalStorage(DC_STORAGE_KEY.USER_DATA)
    if (Object.keys(corpForm).length > 0) {
      // POST
      if (Object.keys(lForm).length > 0) {
        this.userForm = lForm
      } else {
        this.userForm.email = corpForm.email
        App.setLocalStorage(DC_STORAGE_KEY.USER_DATA, this.userForm)
      }
      this.isRequestPayment = corpForm.requestPayment
    } else {
      // GET
      this.tokenCheck()
      if (Object.keys(lForm).length > 0) {
        this.userForm = lForm
      } else {
        this.$set(this.userForm, 'email', this.$route.query.email)
        this.$set(this.userForm, 'corpUserId', this.$route.query.userId)
        App.setLocalStorage(DC_STORAGE_KEY.USER_DATA, this.userForm)
      }
    }
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/RegistUserInput.vue